import { InputGroupDesignTokens } from '@primeuix/themes/types/inputgroup';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/inputgroup/index.ts
const ig = componentCommon.inputgroup;

export const InputGroupTelekomDT: InputGroupDesignTokens = {
  addon: {
    background: t(ig.addon.background),
    borderColor: t(ig.addon.border.color),
    color: t(ig.addon.color),
    borderRadius: t(ig.addon.border.radius),
    padding: t(ig.addon.padding),
    minWidth: t(ig.addon.min.width),
  },
};
